import { ReactNode } from "react";
import { TableProps } from "./table";
import cn from "clsx";

export interface Row {
  rowHeader?: ReactNode;
  data?: Array<ReactNode>;
  rows?: Array<Row>;
  isBold?: boolean;
}

export interface TableRowProps {
  row: Row;
  columnHeaders?: TableProps["columnHeaders"];
  isSubRow?: boolean;
  isNewGroup?: boolean;
}

export function TableRow({
  row,
  columnHeaders,
  isSubRow,
  isNewGroup = false,
}: TableRowProps) {
  const hasData = row.data?.some((h) => Boolean(h));

  let fullWidthSpan = row.rows ? row.rows[0]?.data?.length : undefined;

  if (fullWidthSpan !== undefined) {
    fullWidthSpan += 1;
  }

  const totalColumns = (row.data?.length ?? 1) + 2;
  const colspan = 2;
  const wideCellWidth = (colspan / totalColumns) * 100; //for first/header cell
  const remainingWidth = (1 / totalColumns) * 100; //for indidual cells

  return (
    <tr
      className={cn(
        isSubRow ? "hbs-table-child-row" : "hbs-table-row",
        isNewGroup ? "hbs-table-rowgroup-top" : "",
        row.isBold ? "hbs-table-row-bold" : "",
      )}
    >
      {row.rowHeader && (
        <th
          colSpan={!hasData ? fullWidthSpan : undefined}
          className={
            hasData && row.data && row.data.length > 3 ? "wideCell" : undefined
          }
          scope="row"
          style={
            hasData && row.data && row.data.length > 3
              ? { width: `${wideCellWidth}%` }
              : undefined
          }
        >
          {row.rowHeader}
        </th>
      )}

      {hasData &&
        row.data?.map((data, i) => {
          const filteredColumnHeaders = columnHeaders?.filter((h) =>
            Boolean(h.data),
          );
          const hasColumnHeaders =
            filteredColumnHeaders && filteredColumnHeaders.length > 0;
          const dataIndex = hasColumnHeaders
            ? i % filteredColumnHeaders.length
            : undefined;

          return (
            <td
              key={i}
              data-index={dataIndex}
              data-column-header={
                hasColumnHeaders && dataIndex !== undefined
                  ? filteredColumnHeaders[dataIndex]?.data
                  : undefined
              }
              className={cn(
                !row.rowHeader && "no-row-header",
                hasColumnHeaders && dataIndex !== undefined
                  ? filteredColumnHeaders[dataIndex]?.isBold
                    ? "hbs-table-cell-bold"
                    : ""
                  : "",
                hasColumnHeaders && dataIndex !== undefined
                  ? filteredColumnHeaders[dataIndex]?.hrRule
                    ? "hbs-table-cell-hr-rule"
                    : ""
                  : "",
              )}
              style={
                hasData && row.data && row.data.length > 3
                  ? { width: `${remainingWidth}%` }
                  : undefined
              }
            >
              {data}
            </td>
          );
        })}
    </tr>
  );
}
